import React, {useState} from 'react'
import fetcher from "lib/utils/fetcher";
import Breadcrumbs from '@/components/common/Breadcrumbs'
import {wrapper} from 'store/store'
import SeoData from '@/components/core/SeoData'
import {buildPagination} from "@/lib/utils/pagination";
import contentStyles from "@/public/styles/pages/food/category.module.scss";
import {useRouter} from "next/router";
import Link from "next/link";
import {request} from '@/lib/utils/request'
import {connect} from "react-redux";
import cx from "classnames";

const API_HOST = process.env.NEXT_PUBLIC_API_URL;
const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN

async function loadItems(page, pageSize, urlKey) {
    const fetchPostsUrl = `/api/food/category/${urlKey}/posts?page=${page}&page_size=${pageSize}`
    let day = 24 * 1000 * 60
    return await request(fetchPostsUrl, 'GET', null,true, day * 30)
}


export const getServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
    ctx.res.setHeader(
        "Cache-Control",
        "max-age=300, stale-while-revalidate=60, stale-if-error=86400"
    );

    if (!ctx.query) {
        return {
            notFound: true,
        }
    }
    const {urlKey} = ctx.query;

    let page = ctx.query.page || 1;

    let pageSize = 200;
    let category: any = false;

    try {
        const fetchUrl = `${API_HOST}/api/food/category/url_key/${urlKey}`
        category = await fetcher(fetchUrl);
    } catch (e) {
        console.log(e.message)
    }

    if (!category) {
        return {
            notFound: true,
        }
    }

    const postsList = await loadItems(page, pageSize, urlKey);

    return {
        props: {
            initPage: page,
            category: category,
            totalCount: postsList.total_count,
            foods: postsList.items
        }
    };
})

function Category(props) {
    const router = useRouter();

    const {category, foods, totalCount, initPage, isMobile} = props

    const [items, setItems] = useState(foods)
    const [currentPage, setCurrentPage] = useState<number>(parseInt(initPage))
    let pageSize = 200;

    let breadcrumbs = [];

    breadcrumbs.push({
        path: "/food/calories",
        title: 'Калорийность продуктов'
    })

    breadcrumbs.push({
        path: "",
        title: category.name,
        disabled: true
    })

    const totalPages = Math.ceil(totalCount / pageSize)
    let pagesToShow = buildPagination(currentPage, totalPages)

    return (
        <>
            <SeoData title={`Таблица калорийности категории ${category.name}. Химический состав продуктов питания.`}
                     description={`Таблица калорийности ${category.name}. Химический состав продуктов питания. БЖУ ${category.name} на 100 грамм продукта. Белки, жиры, углеводы в продуктах`}
                     keywords={`${category.name}, Таблица калорийности, БЖУ`}
            />
            {
                !isMobile &&
                <Breadcrumbs
                    items={breadcrumbs}
                />
            }

            <div className={cx(contentStyles.contentContainer, {[contentStyles.noCrumbs]: isMobile})}>
                <div className={contentStyles.headerWrap}>
                    <h1>Таблица калорийности {category.name}. Химический состав продуктов питания.</h1>
                </div>

                <p className={contentStyles.description}>
                    Таблица содержит значение калорий, белков, жиров, углеводов для продуктов, относящихся к категории {category.name.toLowerCase()}, значение макронутриентов приводится на 100 грамм съедобной части продукта. Справочник содержит КБЖУ продуктов, подробную информацию о составе каждого продукта категории {category.name.toLowerCase()} можно найти кликнув на сам продукт в приведенной таблице, на странице самого продукты вы можете узнать о количестве витаминов, минеральных веществ (микроэлементов и макроэлементов), а также получить точную оценку продукта, узнать о пользе и вреде, которые требуется знать при составлении своего меню.
                </p>
                <p className={contentStyles.description}>(Таблица калорийности и содержания белков, жиров и углеводов в 100 граммах продукта)</p>

                <div className={contentStyles.foodItems}>
                    <div className={contentStyles.tableWrap}>
                        <table>
                            <thead>
                            <tr>
                                <th className={contentStyles.name}>Продукт</th>
                                <th className={contentStyles.calories}>Калорийность</th>
                                <th className={contentStyles.proteins}>Белки</th>
                                <th className={contentStyles.fats}>Жиры</th>
                                <th className={contentStyles.carbohydrates}>Углеводы</th>
                            </tr>
                            </thead>
                            <tbody>
                            {items.map((item) => {
                                return <tr>
                                    <td className={contentStyles.name}><Link href={`/food/calories/${item.url_key}`}><a>{item.name}</a></Link></td>
                                    <td className={contentStyles.calories}>{item.calories}</td>
                                    <td className={contentStyles.proteins}>{item.proteins}</td>
                                    <td className={contentStyles.fats}>{item.fats}</td>
                                    <td className={contentStyles.carbohydrates}>{item.carbohydrates}</td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={contentStyles.paginationContainer}>
                    {
                        (currentPage < totalPages) &&
                        <div className={contentStyles.loadMore} onClick={async (e) => {
                            e.preventDefault();
                            const newList = await loadItems(currentPage + 1, pageSize, category.url_key)
                            let newItems = newList.items

                            router.push(
                                {
                                    pathname: `/food/category/${category.url_key}`,
                                    query: {page: newList.current_page}
                                },
                                undefined,
                                {shallow: true}
                            );

                            setItems([...items, ...newItems]);
                            setCurrentPage(newList.current_page);
                        }}><span>Загрузить еще</span></div>
                    }

                    {totalPages > 1 &&
                    <div className={contentStyles.pagination}>
                        {
                            (currentPage != 1) &&
                            <a href={`/food/category/${category.url_key}?page=${currentPage - 1}`}
                               onClick={async (e) => {
                                   e.preventDefault();

                                   const newList = await loadItems(currentPage - 1, pageSize, category.url_key)
                                   let newItems = newList.items

                                   router.push(
                                       {
                                           pathname: `/food/category/${category.url_key}`,
                                           query: {page: newList.current_page}
                                       },
                                       undefined,
                                       {shallow: true}
                                   );

                                   setItems(newItems);
                                   setCurrentPage(newList.current_page);
                               }}>Назад</a>
                        }
                        {
                            <a href={`/food/category/${category.url_key}`}
                               onClick={async (e) => {
                                   e.preventDefault();

                                   const newList = await loadItems(1, pageSize, category.url_key)
                                   let newItems = newList.items

                                   router.push(
                                       {
                                           pathname: `/food/category/${category.url_key}`,
                                           query: {page: 1}
                                       },
                                       undefined,
                                       {shallow: true}
                                   );

                                   setItems(newItems);
                                   setCurrentPage(newList.current_page);
                               }}
                               className={(currentPage == 1) ? contentStyles.currentPage : contentStyles.defaultPage}>1</a>
                        }
                        {
                            (1 == currentPage && 1 != totalPages) &&
                            <div className={contentStyles.pageLine}></div>
                        }
                        {
                            pagesToShow.map(page => {
                                return (
                                    <span key={page}>
                                        <a href={`/food/category/${category.url_key}?page=${page}`}
                                           onClick={async (e) => {
                                               e.preventDefault();

                                               const newList = await loadItems(page, pageSize, category.url_key)
                                               let newItems = newList.items

                                               router.push(
                                                   {
                                                       pathname: `/food/category/${category.url_key}`,
                                                       query: {page:page}
                                                   },
                                                   undefined,
                                                   {shallow: true}
                                               );

                                               setItems(newItems);
                                               setCurrentPage(newList.current_page);
                                           }}
                                           className={(currentPage == page) ? contentStyles.currentPage : contentStyles.defaultPage}>{page}</a>
                                        {
                                            (page == currentPage && page != totalPages) &&
                                            <div className={contentStyles.pageLine}></div>
                                        }
                                    </span>
                                )
                            })
                        }
                        {
                            (currentPage != totalPages) &&
                            <a href={`/food/category/${category.url_key}?page=${totalPages}`}
                               onClick={async (e) => {
                                e.preventDefault();
                                const newList = await loadItems(totalPages, pageSize, category.url_key)
                                let newItems = newList.items

                                router.push(
                                    {
                                        pathname: `/food/category/${category.url_key}`,
                                        query: {page: totalPages}
                                    },
                                    undefined,
                                    {shallow: true}
                                );

                                setItems(newItems);
                                setCurrentPage(newList.current_page);
                            }}
                               className={(currentPage == totalPages) ? contentStyles.currentPage : contentStyles.defaultPage}>{totalPages}</a>
                        }
                        {
                            (currentPage != totalPages) &&
                            <a href={`/food/category/${category.url_key}?page=${currentPage + 1}`}
                               onClick={async (e) => {
                                   e.preventDefault();

                                   const newList = await loadItems(currentPage - 1, pageSize, category.url_key)
                                   let newItems = newList.items

                                   router.push(
                                       {
                                           pathname: `/food/category/${category.url_key}`,
                                           query: {page: currentPage + 1}
                                       },
                                       undefined,
                                       {shallow: true}
                                   );

                                   setItems(newItems);
                                   setCurrentPage(newList.current_page);
                               }}>Вперед</a>
                        }
                    </div>
                    }
                </div>
            </div>
            {
                isMobile &&
                <Breadcrumbs
                    items={breadcrumbs}
                />
            }
        </>
    )
}

function mapStateToProps(state) {
    return {
        isMobile: state.core.is_mobile
    }
}

export default connect(mapStateToProps)(Category)